export default __webpack_public_path__ + "static/media/image404.64a35c1a.svg";